<input class="form-control" type="text" [(ngModel)]="typeaheadValue"
	[typeahead]="entities"
	[typeaheadAsync]="true"
	(typeaheadLoading)="changeTypeaheadLoading($event)"
	(typeaheadOnSelect)="typeaheadOnSelect($event)"
	typeaheadOptionField="name" />